// @flow

import React from 'react';
import { isEmpty } from 'lodash';

import { AppAlternativesOverview } from '@zapier/design-system-app-profiles';
import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/common-components';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import appAlternativesOverviewQuery from 'web-ssr/app/app-directory/components/AppAlternativesOverview/appAlternativesOverviewQuery';
import {
  createAppAlternativesPageLink,
  createAppsPageLink,
} from 'web-ssr/app/app-directory/utils';

import type {
  appAlternativesOverviewQuery as appAlternativesOverviewQueryType,
  appAlternativesOverviewQueryVariables,
} from 'web-ssr/graphql/types';

type Result = {
  loading: *,
  fetchMore: *,
  error: *,
  data: appAlternativesOverviewQueryType,
};

type Props = {
  appSlug: string,
};

const AppAlternativesOverviewContainer = (props: Props) => {
  const { appSlug } = props;

  const layoutProps = useMediaProps({
    [Screen.queries.phone]: { size: 'small' },
    [Screen.queries.phablet]: { size: 'small' },
    [Screen.queries.tablet]: { size: 'medium' },
    [Screen.queries.desktop]: { size: 'large' },
  });

  const variables: appAlternativesOverviewQueryVariables = {
    slug: appSlug,
  };

  return (
    <ApolloQuery query={appAlternativesOverviewQuery} variables={variables}>
      {(result: Result) => {
        const { appBySlug } = result.data || {};

        if (
          !appBySlug ||
          !appBySlug.reviewPage ||
          !appBySlug.reviewPage.similarApps ||
          isEmpty(appBySlug.reviewPage.similarApps)
        ) {
          return null;
        }

        const alternatives = appBySlug.reviewPage.similarApps.map(alt => ({
          slug: alt.slug,
          name: alt.name,
          image: alt.image,
          href: createAppsPageLink(alt.slug),
          categories: alt.categories.map(cat => cat.name),
        }));

        return (
          <AppAlternativesOverview
            alternatives={alternatives}
            appName={appBySlug.name}
            appSlug={appSlug}
            seeAllLink={createAppAlternativesPageLink(appSlug)}
            size={layoutProps.size}
          />
        );
      }}
    </ApolloQuery>
  );
};

export default AppAlternativesOverviewContainer;
